import { ref } from 'vue'
import { getI18n } from '@/plugins/i18n'

import { useGarageStore } from '@/stores/garage.store'
import { useRegistryStore } from '@/stores/registry.store'
import { useWebSiteStore } from '@/stores/web-site.store'

import { codeNameDisplayExpr, customerDisplayExpr } from '@/composables/label'
import { usePortalStore } from '@/stores/portal.store'
import { useSaleStore } from '@/stores/sale.store'

import { usePriceService } from '@/services/price.service'

export const useDocumentService = () => {
  const i18n = getI18n()
  const garageStore = useGarageStore()
  const registryStore = useRegistryStore()
  const webSiteStore = useWebSiteStore()
  const portalStore = usePortalStore()
  const saleStore = useSaleStore()

  const { getIncludesVatValue } = usePriceService()

  const currentVehicleRevisionDueDate = ref(null)

  const extractReferenceData = (ref) => {
    return [
      { key: i18n.t('common.documentType'), value: portalStore.getDocumentTypeName(ref.type) },
      { key: i18n.t('common.series'), value: ref.series },
      { key: i18n.t('common.number'), value: ref.number_mnemonic },
      { key: i18n.t('common.date'), value: ref.date },
      { key: i18n.t('common.supplierBrand'), value: codeNameDisplayExpr(registryStore.getSupplierBrandById(ref.supplier_brand_ref)) },
      { key: i18n.t('common.workReason'), value: codeNameDisplayExpr(garageStore.getLocalizedGarageReasons().find(i => i.id === ref.garage_reason_ref)) },
      { key: i18n.t('common.garage'), value: codeNameDisplayExpr(registryStore.getLocalizedDeposits().find(i => i.id === ref.garage)) },
      { key: i18n.t('common.deposit'), value: codeNameDisplayExpr(registryStore.getLocalizedDeposits().find(i => i.id === ref.deposit)) },
      { key: i18n.t('common.customer'), value: customerDisplayExpr(registryStore.customers.find(i => i.id === ref.customer_id)) },
      { key: i18n.t('common.paymentType'), value: codeNameDisplayExpr(webSiteStore.getLocalizedPaymentTypes().find(i => i.id === ref.payment_type_ref)) },
    ]
  }

  const setSdiDocumentTypeValue = (currentData, newData) => {
    let sdi_document_type_id = saleStore.getLocalizedSaleReasons().find(i => i.id === currentData.sale_reason_ref)?.sdi_document_type
    if (!sdi_document_type_id) {
      sdi_document_type_id = portalStore.getLocalizedElectronicInvoiceSdiDocumentTypes().find(i => i.code === portalStore.electronicInvoiceSdiDocumentTypeEnum.INVOICE)?.id
    }
    newData.sdi_document_type = portalStore.getLocalizedElectronicInvoiceSdiDocumentTypes().find(i => i.id === sdi_document_type_id)?.code
  }

  const setVehicleNextRevisionDueDate = (data) => {
    if (data?.vehicle?.revision_due_date) {
      currentVehicleRevisionDueDate.value = data.vehicle.revision_due_date
      data.vehicle.next_revision_due_date = data.vehicle.revision_due_date
    }
  }

  const setIncludesVat = (newData, value, currentData, includesVat, customer) => {
    if (!currentData.rows_count) { // HACK: remove this when the read-only fields US (801) for documents with rows is implemented
      newData.includes_vat = includesVat.value = getIncludesVatValue(customer)
    }
  }

  return {
    currentVehicleRevisionDueDate,
    extractReferenceData,
    setIncludesVat,
    setSdiDocumentTypeValue,
    setVehicleNextRevisionDueDate,
  }
}

